module.exports = __webpack_public_path__ + "media/images/proposal/hall-list/proposal-halllist-6-741109de635c7e4a4da9a97ad6f68634.png";